import * as React from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Login } from "./Login/Login";
import PageLoader from "./Common/Components/PageLoader";
import './Common/Assets/Styles/globals.css';

import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from 'moment-timezone'; // Import moment-timezone

// Login is the entry point for unauthenticated visitors, so it stays in the
// initial bundle. Everything else is fetched only once its route is reached.
const lazyNamed = (loader: () => Promise<any>, exportName: string) =>
  React.lazy(() => loader().then((module) => ({ default: module[exportName] })));

const ProtectedLayout = lazyNamed(
  () => import("./Common/Components/ProtectedLayout"),
  "ProtectedLayout"
);
const RestoreSession = lazyNamed(
  () => import("./Common/Components/RestoreSession"),
  "RestoreSession"
);
const Maintenance = lazyNamed(() => import("./Login/Under-Maintenance"), "Maintenance");
const Logout = lazyNamed(() => import("./Login/Logout"), "Logout");
const PunchLogin = lazyNamed(() => import("./Login/PunchLogin"), "PunchLogin");
const PunchInOut = lazyNamed(() => import("./Modules/PunchInOut/PunchInOut"), "PunchInOut");
const Vendor = lazyNamed(() => import("./Modules/Vendor"), "Vendor");


const App: React.FC = () => {
  let appClassName: string = "App";
  if (window.innerWidth <= 1200 && window.innerWidth >= 1000) {
    appClassName = `${appClassName} small-width`;
  }

  // Set the default timezone to New York
  React.useEffect(() => {
    moment.tz.setDefault("America/New_York");
  }, []);


  return (
    <div  >
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {  
      <Router>
        <React.Suspense fallback={<PageLoader />}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/punch-login" component={PunchLogin} />
          <Route exact path="/punch-in-out" component={PunchInOut} />
          <Route exact path="/Vendor" component={Vendor} />

         
          <Route path="/Under-Maintenance" component={Maintenance} />
          <Route path="/RestoreSession" component={RestoreSession} />
          <Route path="/" component={ProtectedLayout}> 
          {/* <Route path="/" component={Header} /> */}
        </Route>
         
        </Switch>
        </React.Suspense>
      </Router> }  

{/* {  <Router>
      <Switch>
        <Route exact path="/login" component={Login}/>
        <Route exact path="/logout" component={Logout} />
          <Route exact component={ProtectedLayout} />
          <Route path="Home">
            <Route exact component={Home} />
          </Route>
          
        
      </Switch>
    </Router>  } */}
    </div>
  );
};

export default App;
